import { startCase, camelCase } from 'lodash';

export function titleize(str: string): string | undefined {
  if (!str) {
    return undefined;
  }

  return startCase(camelCase(str));
}
